import { Component, OnInit } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';

@Component({
  selector: 'app-promote-jobs-offer-dialog',
  templateUrl: './promote-jobs-offer-dialog.component.html',
  styleUrls: ['./promote-jobs-offer-dialog.component.css']
})
export class PromoteJobsOfferDialogComponent implements OnInit {

  constructor(public dialogRef: MdDialogRef<PromoteJobsOfferDialogComponent>) { }

  ngOnInit() {
  }

  promotionId;
  credits;
  promotion=[
    {
      id:1,
      name:'Promoción 1',
      mount:70,
    },
    {
      id:2,
      name:'Promoción 2',
      mount:80,
    },
    {
      id:3,
      name:'Promoción 3',
      mount:90,
    }
  ]

}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/promote-jobs-offer-dialog/promote-jobs-offer-dialog.component.ts